import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/mapa/step1';
import { TypeCoord } from '../models/TypeCoord';


@Component({
  selector: 'app-type-coord',
  templateUrl: './type-coord.component.html'
})
export class TypeCoordComponent implements OnInit {

  constructor() {}
  @Input() uid = '';

  public current_uid = 'TypeCoord';
  @Input() parentForm: FormGroup;
  @Input() coord: TypeCoord;
  @Input() disabled: boolean;

  public step1 = new Step1();

  public ngOnInit() {

  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
